import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  custom: {
    ui: UiState.Idle,
    config: null
  }
};

const fetchCustomShipmentConfigRequest = draft => {
  draft.custom.ui = UiState.Pending;
};

const fetchCustomShipmentConfigSuccess = (draft, action) => {
  draft.custom.ui = UiState.Success;
  draft.custom.config = action.payload.config;
};

const fetchCustomShipmentConfigFailure = draft => {
  draft.custom.ui = UiState.Failure;
};

const shipmentConfigSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchCustomShipmentConfigRequest,
    fetchCustomShipmentConfigSuccess,
    fetchCustomShipmentConfigFailure
  }
});
export const {
  actions
} = shipmentConfigSlice;
export const plug = {
  [stateName]: shipmentConfigSlice.reducer
};
export default shipmentConfigSlice.reducer;